import { ArrowCircleRightOutlined } from '@mui/icons-material'
import { Grid } from '@mui/material'
import SubmitButton from 'components/atoms/buttons/SubmitButton'
import InputField from 'components/atoms/fields/InputField'
import { Form, Formik } from 'formik'
import _ from 'lodash'
import { FC, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { FaTrash, FaTrashAlt } from 'react-icons/fa'
import { useDispatch, useSelector } from 'react-redux'
import { useGET_goalByIdQuery } from 'redux/api/goalbankApi'
import { useGET_setupOptionsQuery } from 'redux/api/setupApi'
import { AppDispatch, RootState } from 'redux/store'
import { setGoalbankSelection } from 'redux/ui/goalbankUI'
import { GOALBANK_ITEM_TYPES, goalbankSelectionRemoveItem, toHtml } from 'utils/helpers'

// Sidebar sections shown before "all other characteristics" is clicked
const VISIBLE_SECTIONS_COUNT = 5

interface IProps {
  hasSelection?: boolean
  visibleSections?: string[]
  disabledSections?: string[]
  setupPrefix?: string,
  goal: any,
  handleSelectUnit: any
}


const Goal: FC<IProps> = ({ goal, hasSelection=false, visibleSections=[], disabledSections=[], setupPrefix="", handleSelectUnit=()=>{} }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch<AppDispatch>()
  
  const sections = GOALBANK_ITEM_TYPES
  const hiddenSections = ["clusters", "goals", "units", "objectives"]
  
  Object.keys(sections).forEach(k => {
    const [deleteFn] = sections[k].deleteHook ? sections[k].deleteHook() : [null]
    sections[k]["deleteFn"] = deleteFn

    const [addFn] = sections[k].addHook ? sections[k].addHook() : [null]
    sections[k]["addFn"] = addFn
  })

  const [selectedSection, setSelectedSection] = useState(null)
  const [selectedUnit, setSelectedUnit] = useState(null)
  const [showAddForm, setShowAddForm] = useState(false)
  const [seeAllSections, setSeeAllSections] = useState(false)

  const goalbankSelection = useSelector((state: RootState) => state['goalbank'].goalbankSelection)

  const toggleSection = (section, c) => {
    if(!hasSelection)return
    
    let selection = _.cloneDeep(goalbankSelection)
    if(!(goal.id in selection))selection[goal.id]={
      id: goal.id,
      display_code: goal.display_code,
      selection: {}
    }
    if(!(section in selection[goal.id]["selection"]))selection[goal.id]["selection"][section]=[]

    if(selection[goal.id]["selection"][section].filter(s => s.id === c.id).length===0)
      selection[goal.id]["selection"][section].push({
        ...c,
        goal_id: goal.id,
        goal_code: goal.display_code
      })
    else
      selection[goal.id]["selection"][section]=selection[goal.id]["selection"][section].filter(s => s.id !== c.id)

    dispatch(setGoalbankSelection(selection))
  }

 

  const goalbankSectionSelectedItems = (section) => {

    if(!(goal.id in goalbankSelection)) return 0

    if(sections[section].type==="course_chapters")
      return "units" in goalbankSelection[goal.id]["selection"] 
        ? goalbankSelection[goal.id]["selection"]["units"].length : 0
    else
      return section in goalbankSelection[goal.id]["selection"] 
        ? goalbankSelection[goal.id]["selection"][section].length : 0
  }

  const goalbankSectionSelectedUnits = (unit) => {
    
    if(!(goal.id in goalbankSelection)) return 0

    if(!("course_chapters" in goalbankSelection[goal.id]["selection"]))return 0 
    return goalbankSelection[goal.id]["selection"]["course_chapters"].filter(c => c.unit === unit).length
  }

  const {data: goalDataRes} = useGET_goalByIdQuery(goal.id, {skip: !goal?.id})


 
  const goalData = goalDataRes ? {
    ...goalDataRes,
    section_a: [
      {id: '1', title: t(`goalbank-more.grade-${goalDataRes.display_code?.split('.')[0] ?? '4'}.section-1.item-1`)},
      {id: '2', title: t(`goalbank-more.grade-${goalDataRes.display_code?.split('.')[0] ?? '4'}.section-1.item-2`)},
    ],
    section_b: [
      {id: '3', title: t(`goalbank-more.grade-${goalDataRes.display_code?.split('.')[0] ?? '4'}.section-2.item-1`)},
      {id: '4', title: t(`goalbank-more.grade-${goalDataRes.display_code?.split('.')[0] ?? '4'}.section-2.item-2`)},
    ],
    section_c: [
      {id: '5', title: t(`goalbank-more.grade-${goalDataRes.display_code?.split('.')[0] ?? '4'}.section-3.item-1`)},
      {id: '6', title: t(`goalbank-more.grade-${goalDataRes.display_code?.split('.')[0] ?? '4'}.section-3.item-2`)},
    ],
    section_d: [
      {id: '7', title: t(`goalbank-more.grade-${goalDataRes.display_code?.split('.')[0] ?? '4'}.section-4.item-1`)},
      {id: '8', title: t(`goalbank-more.grade-${goalDataRes.display_code?.split('.')[0] ?? '4'}.section-4.item-2`)},
    ]
  } : goalDataRes

  const { data: setupData } = useGET_setupOptionsQuery(null, {skip: setupPrefix === ""})


  useEffect(() => {
    if(selectedUnit){
      setSelectedUnit(goalData.course_chapters.find(u=>u.id===selectedUnit.id))
    }
  }, [goalData])


  const sidebarSections = goalData && (setupData || setupPrefix === "") ? 
    Object.keys(sections).filter(s => 
      !hiddenSections.includes(s) &&
      (s in goalData && goalData[s].length > 0) &&
      (visibleSections.length == 0 || visibleSections.indexOf(s) > -1) &&
      (setupPrefix === "" || setupData.filter(sd => sd.slug == setupPrefix+"_"+s && sd.is_enabled).length == 1)
    ) : []


  return (
    goalData && (setupData || setupPrefix === "") && <>
        <div style={{ fontSize: "18px", cursor: 'pointer' }}  onClick={() => setSelectedSection(null)}><b>{goalData.display_code}</b> {goalData.title}</div>
        <Grid spacing={2} container mt={2}>
            <Grid item xs={12} lg={4}>
                <div style={{ height: '100%', borderRight: '1px solid gray' }}>
                    {sidebarSections.map((k, ki) => <div key={`section_menu_${k}`} style={{ display: ki<VISIBLE_SECTIONS_COUNT || seeAllSections ? 'block' : 'none'}}
                      className={`goalbank-section ${selectedSection==k ? 'selected' : ''}`}>
                        <div className={`goalbank-section-title`}
                            onClick={() => {
                                setShowAddForm(false)
                                setSelectedSection(k)
                                if(sections[k].type==="course_chapters")
                                    setSelectedUnit(goalData.course_chapters[0])

                            }}
                        >{sections[k].title} {goalbankSectionSelectedItems(k) > 0 
                            ? `(${goalbankSectionSelectedItems(k)})` : ''}</div>
                        

                        {sections[k].type==="course_chapters" && selectedSection===k && <div style={{ paddingLeft: "10px", paddingTop: "5px" }}>
                            {goalData.course_chapters.map(unit =>  
                                <div key={`unit_menu_${unit.id}`}>
                                    <span style={{ fontSize: "14px", cursor: "pointer" }} onClick={() =>
                                      {
                                        setShowAddForm(false)
                                        setSelectedUnit(unit)
                                      } 
                                    }>{unit.sort_order}.
                                    
                                      {goalbankSectionSelectedUnits(unit.id) > 0 
                                        ? ` (${goalbankSectionSelectedUnits(unit.id)})` : ''}
                                    </span>
                                </div> )}   
                        </div>}
    
                    </div>)}

                    {sidebarSections.length > VISIBLE_SECTIONS_COUNT && !seeAllSections &&
                      <div className="goalbank-section">
                        <div className="goalbank-section-title" 
                          onClick={() => { setSeeAllSections(true) }} style={{ color: '#000' }}>
                            + {t('goalbank.all-other-characteristics')}
                        </div>
                      </div>
                    }
                </div>
            </Grid>
            <Grid item xs={12} lg={8}>
                <div style={{ paddingLeft: '20px' }}>

                {!selectedSection && <div>
                      
                      {goalData.text && <div dangerouslySetInnerHTML={toHtml(goalData.text)} />}

                </div>}

                  {
                    selectedSection && sections[selectedSection].type==='choices' && <>
                        <div style={{ fontWeight: 'bold', fontSize: '20px', marginBottom: '20px'}}>{sections[selectedSection].title}</div>
                        <div>
                            {(selectedSection in goalData) && goalData[selectedSection].map(c => <div key={`${selectedSection}_${c.id}`}>
                              {hasSelection && !disabledSections.includes(selectedSection) ? <input type="checkbox" 
                                  onChange={(e) => {toggleSection(selectedSection, c)}} 
                                  checked={
                                      (
                                        (goal.id in goalbankSelection) &&
                                        (selectedSection in goalbankSelection[goal.id]["selection"]) && 
                                        goalbankSelection[goal.id]["selection"][selectedSection].filter(sc => sc.id===c.id).length > 0
                                      )
                                       ? true : false }/> 
                                  : <>&bull;</>} <span 
                                    style={{ cursor: 'pointer' }}  
                                    onClick={(e) => {toggleSection(selectedSection, c)}}>{c.title}</span>

                                  {c.can_delete && sections[selectedSection].deleteFn && <FaTrashAlt style={{
                                     marginLeft: '5px',
                                     position: 'relative',
                                     bottom: '-2px',
                                     cursor: 'pointer'
                                     }}

                                     onClick={() => {
                                      sections[selectedSection].deleteFn(c.id)
                                      dispatch(setGoalbankSelection(goalbankSelectionRemoveItem(goalbankSelection,selectedSection,c.id)))
                                     }}
                                     />}

                                  {c.description && <div style={{ whiteSpace: 'pre-line', fontSize: '14px', color: 'gray', margin: '5px 0 15px 20px' }}>
                                    {c.description}
                                  </div>}

                            </div>)
                            }

                              {
                              <div style={{ textAlign: 'right', marginTop: '10px' }}>
                               {!showAddForm && <SubmitButton
                                color={'success'}
                                text={`${t('common.add-new-item')}`}
                                sx={{ width: '10rem' }} 
                                isLoading={false} 
                                onClick={() => setShowAddForm(true)}                           
                                />
                               }

                                {showAddForm && sections[selectedSection].addFn &&
                                   <Formik
                                   enableReinitialize
                                   initialValues={{'title': ''}}
                                   onSubmit={(values: any) => {
                                    sections[selectedSection].addFn({
                                      ...values,
                                      goal_id: goal.id
                                    })
                                    setShowAddForm(false);
                                   }}
                                 >
                                       <Form>
                                         <div style={{ display: 'flex', width: '100%', verticalAlign: 'center' }}>
                                            <div style={{ width: 'calc(100% - 120px)' }}>
                                                <InputField fieldProps={{ label: '', name: 'title' }}  />
                                            </div>
                                            <div style={{ paddingLeft: '5px' }}>
                                              <SubmitButton
                                                 color={'success'}
                                                 text={`Add`}
                                                 sx={{ width: '100px' }}
                                                 isLoading={false}
                                              />
                                             </div>
                                         </div>
                                       </Form>
                                 </Formik>
                                }
                              </div>}
                        </div>

                    </>
                  }  

                  {
                    selectedSection && sections[selectedSection].type==='course_chapters' && selectedUnit  && <>
                        <div className="goalbank-section">
                            <div className="goalbank-section-title" 
                               style={{ fontWeight: 'bold', lineHeight: '14px' }}
                               onClick={() => {
                                handleSelectUnit(selectedUnit.id)
                             }}>
                             
                             {t('goalbank.unit')} {selectedUnit.sort_order}: {selectedUnit.title}
                             <ArrowCircleRightOutlined sx={{ position: 'relative', left: '3px', bottom: '-6px'}} /> 
                            </div>
                          </div>
                        
                        {/*
                        <div>
                          {hasSelection && <input type="checkbox" 
                                onChange={(e) => {toggleSection("units", {
                                  "id": selectedUnit.id,
                                  "title": selectedUnit.title,
                                  "sort_order": selectedUnit.sort_order
                                })}} 
                                checked={
                                  (
                                    (goal.id in goalbankSelection) &&
                                    ("units" in goalbankSelection[goal.id]["selection"]) && 
                                    goalbankSelection[goal.id]["selection"]["units"].filter(su => su.id===selectedUnit.id).length > 0
                                  )
                                   ? true : false }
                            />}
                          {selectedUnit.title}</div> */}


                        <div style={{ paddingTop: '20px' }}>{t('goalbank.learning-progression')}:</div>
                        <div style={{ paddingTop: '10px' }}>
                            {selectedUnit.objectives.map(c => <div key={`${selectedSection}_${c.id}`}>
                              {hasSelection ? <input type="checkbox" 
                                  onChange={(e) => {
                                    toggleSection(selectedSection, {...c, unit: selectedUnit.id})
                                  }} 
                                  checked={
                                    (
                                      (goal.id in goalbankSelection) &&
                                      (selectedSection in goalbankSelection[goal.id]["selection"]) && 
                                      goalbankSelection[goal.id]["selection"][selectedSection].filter(sc => sc.id===c.id).length > 0
                                    )
                                     ? true : false }/> 
                                  : <>&bull;</>} <span style={{ cursor: 'pointer' }} onClick={(e) => {
                                    toggleSection(selectedSection, {...c, unit: selectedUnit.id})
                                  }} >{c.title}</span>
 
                                    {c.can_delete && <FaTrashAlt style={{
                                     marginLeft: '5px',
                                     position: 'relative',
                                     bottom: '-2px',
                                     cursor: 'pointer'
                                     }} 
                                     
                                     onClick={() => {
                                      sections[selectedSection].deleteFn(c.id)
                                      dispatch(setGoalbankSelection(goalbankSelectionRemoveItem(goalbankSelection,selectedSection,c.id)))

                                      /*
                                      let newUnit={
                                        ...selectedUnit,
                                        objectives: selectedUnit["objectives"].filter(o => o.id!==c.id)
                                      }
                                      setSelectedUnit(newUnit)
                                      */

                                     }}
                                     />} 

                            </div>)}


                            {
                              <div style={{ textAlign: 'right', marginTop: '10px' }}>
                               {!showAddForm && <SubmitButton
                                color={'success'}
                                text={`${t('common.add-new-item')}`}
                                sx={{ width: '10rem' }} 
                                isLoading={false} 
                                onClick={() => setShowAddForm(true)}                           
                                />
                               }

                                {showAddForm && 
                                   <Formik
                                   enableReinitialize
                                   initialValues={{'title': ''}}
                                   onSubmit={(values: any) => {
                                    let data = {
                                      ...values,
                                      chapter_id: selectedUnit.id,
                                      goal_id: goal.id
                                    }
                                    sections[selectedSection].addFn(data)
                                    setShowAddForm(false);
                                   }}
                                 >
                                       <Form>
                                         <div style={{ display: 'flex', width: '100%', verticalAlign: 'center' }}>
                                            <div style={{ width: 'calc(100% - 120px)' }}>
                                                <InputField fieldProps={{ label: '', name: 'title' }}  />
                                            </div>
                                            <div style={{ paddingLeft: '5px' }}>
                                              <SubmitButton
                                                 color={'success'}
                                                 text={`Add`}
                                                 sx={{ width: '100px' }}
                                                 isLoading={false}
                                              />
                                             </div>
                                         </div>
                                       </Form>
                                 </Formik>
                                }
                              </div>}


                            
                        </div>
                    </>
                  }  
                </div>            
            </Grid>
        </Grid>      
    </> 
  )
}

export default Goal
